import {AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {MenuItem, SelectItem} from 'primeng/api';

import {BreadcrumbMain, BreadcrumbPayeeMain, BreadcrumbPayroll, CommonDataService, CommonDocRepoService, EnumType, FlsaType, Format, RouteLink, TableColumn, TableFormat} from '@app/shared';
import {Payee, PayeeTaxDocument, PayeeTaxDocumentSearchParam} from '@app/payroll/payroll';
import {ActivatedRoute, Router} from "@angular/router";
import {PayeeDocumentService} from "./payee-document.service";
import {AppraisalAdminDataService} from "../../hr/appraisal-admin/appraisal-admin-data.service";
import {plainToClass} from "class-transformer";
import {PayeeDetailsService} from "@app/payroll/payee-management/services/payee-details.service";

@Component({
  selector: 'app-payee-document',
  templateUrl: './payee-document.component.html',
  styleUrls: ['./payee-document.component.css'],
  providers: [PayeeDocumentService, CommonDocRepoService, AppraisalAdminDataService, PayeeDetailsService]
})
export class PayeeDocumentComponent implements OnInit, AfterViewInit {

  Format: typeof Format = Format;
  @Input() payeeId: number;
  @Input() sourcePage: string;
  payeeDocuments: PayeeTaxDocument[];
  visible: boolean = true;
  payee: Payee;
  status: string;
  public breadcrumb: MenuItem[] = [];
  documentTypeOptions: SelectItem[];
  payeeDocumentsTableColumns: TableColumn[];
  yearDropDown: SelectItem[] = [];
  searchOption: PayeeTaxDocumentSearchParam;

  @ViewChild('actionTemplate') actionTemplate: TemplateRef<any>;

  constructor(private router: Router, private route: ActivatedRoute, private payeeDocumentService: PayeeDocumentService, private appDataService: AppraisalAdminDataService, private docRepoService: CommonDocRepoService, private commonDataService: CommonDataService, private payeeDetailsService: PayeeDetailsService) {
  }

  ngOnInit() {
    this.breadcrumb.push(BreadcrumbMain);
    this.breadcrumb.push(BreadcrumbPayroll);
    this.breadcrumb.push(BreadcrumbPayeeMain);
    this.breadcrumb.push({label: 'Payee Documents', routerLink: ''});
    this.documentTypeOptions = [];
    this.loadInitialData();
  }

  ngAfterViewInit(): void {
    this.initializePayeeDocumentsDataTable();
  }


  loadInitialData() {
    this.searchOption = new PayeeTaxDocumentSearchParam();
    this.searchOption.payeeId = this.payeeId;

    this.payeeDocuments = [];
    this.payee = new Payee();
    this.commonDataService.getEnumPairAsDropdown(EnumType.PayeeFormType).subscribe(
      data => this.documentTypeOptions = data
    );
    this.populateYearDropDown();
    if (this.route.snapshot.params['payeeId']) {
      this.payeeId = this.route.snapshot.params['payeeId'];
    }
    if (this.payeeId) {
      this.getPayeeDocumentsSummary(this.payeeId);
    }
  }

  getPayeeDocumentsSummary(payeeId: number) {
    this.payeeDocumentService.getPayeeDocumentsSummary(payeeId).subscribe(
      data => {
        this.payeeDocuments = data.list;
        this.getPayeeDetails(this.payeeId);
      },
    );
  }

  getPayeeDetails(payeeId: number) {
    this.payeeDetailsService.getPayeeDetailsById(payeeId).subscribe(
      data => {
        this.payee = plainToClass(Payee, data as Payee);
        this.getAdditionalPayeeData();
      },
    );
  }

  getAdditionalPayeeData() {
    if (this.payee.flsaType == FlsaType.Exempt) {
      this.status = 'Salaried';
    } else {
      this.status = 'Hourly';
    }
  }


  onClickDownload(selectedRow) {
    console.log("taxFormPDFId->", selectedRow.taxFormPDFId);
    this.docRepoService.getFileByIdThenSave(selectedRow.taxFormPDFId);
  }

  onClickView(selectedRow) {
    console.log("taxFormPDFId->", selectedRow.taxFormPDFId);
    this.docRepoService.getFileByIdThenShowOnNewTab(selectedRow.taxFormPDFId);
  }

  populateYearDropDown() {
    this.appDataService.getFinancialYear().subscribe(year => {
      let financialYears = year.sort((a, b) => b.name - a.name);
      financialYears.forEach(yr => {
        this.yearDropDown.push({label: yr, value: yr});
      });
    });
  }

  goToPayeeMainUI() {
    this.router.navigate([RouteLink.PayeeMain]);
  }

  onClickClearSearchOption() {
    this.searchOption = new PayeeTaxDocumentSearchParam();
    this.searchOption.payeeId = this.payeeId;
    //console.log(this.payeeId);
  }

  onClickSearchPD(searchOption: PayeeTaxDocumentSearchParam) {
    searchOption.payeeId = this.payeeId;
    //console.log(searchOption.payeeId);
    this.payeeDocumentService.searchPayeeDocuments(searchOption).subscribe(data => {
      this.payeeDocuments = data.list;
    });
  }

  private initializePayeeDocumentsDataTable(): void {
    this.payeeDocumentsTableColumns = [
      {field: 'payeeFormType', header: 'Document Type', format: TableFormat.TitleCase},
      {field: 'checkDate', header: 'Check Date', format: TableFormat.Date},
      {field: 'action', header: 'Action', template: this.actionTemplate},
    ];
  }
}
